import React, { useEffect, useState, useRef } from 'react';
import * as RB from 'rebass';
import './homepage.css';
import CanvasJSReact from '@canvasjs/react-charts';

import HeaderBar from '../headerBar/headerBar';
import Wallboard from "../wallboard/wallboard";
import Notification from "../notification/Notification";
import { connect } from 'react-redux';
import {useUserIP} from "../config/config";

import 'amazon-connect-streams';
import { AgentClient } from "@amazon-connect/contact";
import { AmazonConnectApp } from "@amazon-connect/app";
import {CCol, CContainer, CRow} from "@coreui/react-pro";
// import { user_info } from "../config/config";
import axios from "axios";
import { setNotificationHeader, setNotificationMessage, setNotificationType } from "../config/Redux/actions";
import { useNavigate } from "react-router-dom";


function HomePage(props) {
    const [agentID, setAgentID] = useState("");
    const [userInfo, setUserInfo] = useState({});
    const [lobModalVisible, setLobModalVisible] = useState(false);
    const [selectedLOB, setSelectedLOB] = useState(() => {
        const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith('selectedLOB='));
        return cookie ? cookie.split('=')[1] : 'CCC';
    });


    const [agentInit, setAgentInit] = useState(false);
    const [agentName, setAgentName] = useState("");
    const [agentStatus, setAgentStatus] = useState("");
    const [agentUsername, setAgentUsername] = useState("");
    const [token, setToken] = useState("");
    const dashboardRef = useRef(null); // Ref for embedding QuickSight dashboard

    const navigate = useNavigate();

    function showNotification(message, notificationHeader, notificationType) {
        props.setNotificationMessage(message);
        props.setNotificationType(notificationType);
        props.setNotificationHeader(notificationHeader);
    }

    const handleLOBChange = (newLOB) => {
        setSelectedLOB(newLOB);
        const expires = new Date();
        expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
        document.cookie = `selectedLOB=${newLOB};expires=${expires.toUTCString()};path=/`;
    };


    useEffect(async () => {
        // Check and initialize agent
        try {
            const { provider } = AmazonConnectApp.init({
                onCreate: async (event) => {
                    const {appInstanceId} = event.context;
                    console.log('App initialized: ', appInstanceId);
                    const agentClient = new AgentClient();
                    const agentArn = await agentClient.getARN();
                    const agentIDPart = agentArn.split("/agent/")
                    console.log("AGENT ID", agentIDPart)
                    setAgentID(agentIDPart[1])
                },
                onDestroy: (event) => {
                    console.log('App being destroyed');
                },
            });


        } catch (error) {
            console.log("No agent found", error)
        }

    }, []);

    useEffect(() => {
        const msalAccountKeys = sessionStorage.getItem("msal.account.keys")
        if(msalAccountKeys){
            const user = JSON.parse(sessionStorage.getItem(JSON.parse(msalAccountKeys)[0])).username;
            setAgentUsername(user)
            console.log("USERNAME - ", user)
        }
    })


    // Dynamically scale the container based on the viewport size
    const scale = Math.min(window.innerWidth / 1920, window.innerHeight / 1080);


    return (
        <>
            <div>
                {(agentUsername) && (
                    <>
                    <Notification />
                    <HeaderBar
                    agent={{ id: agentID, username: agentUsername }}
                lob={selectedLOB}
                onLOBChange={handleLOBChange}
                showLobModal={() => setLobModalVisible(true)}
            /><br/>
            {/*<CContainer>*/}
            <Wallboard
                lob={selectedLOB}
                agent={{ id: agentID, username: agentUsername }}
                onLOBChange={handleLOBChange}
                modalVisible={lobModalVisible}
                setModalVisible={setLobModalVisible}
                setSelectedLOB={setSelectedLOB}
                selectedLOB={selectedLOB}
            />
                    </>
                )}

                {/*</CContainer>*/}
                {/*<CContainer ref={dashboardRef} />*/}
            </div>
        </>
    );
}

const mapDispatchToProps = {
    setNotificationMessage,
    setNotificationHeader,
    setNotificationType
};

export default connect(null, mapDispatchToProps)(HomePage);
